import { inject } from '@angular/core'
import { CanActivateFn, RedirectCommand, Router } from '@angular/router'
import { AuthService } from './services/auth.service'

// Any signed in user
export const authGuard: CanActivateFn = () => {
  const currentUser = inject(AuthService).user()
  if (!currentUser) {
    const redirectPath = inject(Router).parseUrl('/account/sign-in')
    return new RedirectCommand(redirectPath)
  }
  return true
}

// Only owner can access
export const isOwnerGuard: CanActivateFn = () => {
  const auth = inject(AuthService)

  const currentUser = auth.user()
  const isOwner = !!currentUser && auth.asOwner()
  if (!isOwner) {
    const redirectPath = inject(Router).parseUrl('/account/sign-in')
    return new RedirectCommand(redirectPath)
  }
  return true
}
